export const SelectedViewer = {
  ThreeSixty: 'ThreeSixtyViewer',
  ThreeD: 'ModelViewer',
  TwoD: 'Lifestyle',
};

export const DEFAULT_ENV_ROTATION_DEGREES = [0, 90, 0];
export const DEFAULT_ENV_ROTATION_RADIANS = DEFAULT_ENV_ROTATION_DEGREES.map((deg) => deg * Math.PI / 180);
export const ENV_ROTATION_AXES = ['X', 'Y', 'Z'];
